export default {
      id: "ic-misc-mobile-usage",
      viewBox: "0 0 26 26",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-misc-mobile-usage",
      toString: function () {
        return this.url;
      }
    }